module.exports = __webpack_public_path__ + "static/media/peopleListeningMusic.072165ae.png";